import moment from "moment";
import React from "react";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2I1 } from "../../../../../redux/app/bfl-2/groups/bfl2-i";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2I1PreviewProps = OwnProps;
function BFL2I1Preview(props: BFL2I1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2I1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "I", 1, renderItem1()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<>
				<h4 className="font-medium uppercase">
					{biofoulingRecord.item1.otherDeviations
						? biofoulingRecord.item1.otherDeviations
						: "-----"}
				</h4>
				{biofoulingRecord.item1.recordAttachment != " " ? (
					<h3 className="font-medium uppercase">
						Attachment: {biofoulingRecord.item1.recordAttachment}
					</h3>
				) : null}
			</>
		);
	}

	return renderMain();
}

export default BFL2I1Preview;
